import { Component, inject } from '@angular/core';
import { WorkflowEditorService } from './workflow-editor/workflow-editor.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [SidebarComponent, HeaderComponent, RouterOutlet, AsyncPipe],
})
export class DashboardComponent {
  private workflowEditorService = inject(WorkflowEditorService);

  get immersiveWorkflow() {
    return this.workflowEditorService.immersiveCanvas;
  }
}
